/**
 * Format an ingredient quantity for display. Renders the common fractions as
 * unicode glyphs (½, ⅓, ¼ …) and strips trailing zeros otherwise so "2.0"
 * shows as "2".
 */
const COMMON_FRACTIONS: Record<string, string> = {
  "0.5": "½",
  "0.25": "¼",
  "0.75": "¾",
  "0.333": "⅓",
  "0.667": "⅔",
  "0.125": "⅛",
};
export function formatQty(qty: number): string {
  if (!Number.isFinite(qty)) return "";
  const whole = Math.floor(qty);
  const frac = qty - whole;
  if (frac === 0) return String(whole);
  // Match by rounded 3-decimal key (catches 0.3333… / 0.6667…)
  const key = frac.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
  const glyph = COMMON_FRACTIONS[key];
  if (glyph !== undefined) return whole === 0 ? glyph : `${whole}${glyph}`;
  // Otherwise: up to 2 decimals, strip trailing zeros.
  return qty.toFixed(2).replace(/\.?0+$/, "");
}

/**
 * Format a servings-scale factor for the muted "scaled ×N" note, e.g.
 * `1.5`, `2`, `0.5` — trims trailing zeros the same way formatQty does.
 */
export function formatFactor(factor: number): string {
  return factor.toFixed(2).replace(/\.?0+$/, "");
}
